/** Seconds as m:ss, the way a call timer reads: 6:07, 12:40, 0:09. */
export const mmss = (seconds: number | null | undefined) => {
  if (seconds == null || Number.isNaN(seconds)) return "—"
  const s = Math.max(0, Math.round(seconds))
  const m = Math.floor(s / 60)
  return `${m}:${String(s % 60).padStart(2, "0")}`
}

/** Whole seconds since an ISO stamp, never negative; null when there is no stamp. */
export const secondsSince = (
  iso: string | null | undefined,
  now = Date.now(),
) =>
  iso ? Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000)) : null

/** A wall-clock stamp in the instrument's voice: 11:39:02. */
export const clockStamp = (iso: string) =>
  new Date(iso).toLocaleTimeString("en-AU", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  })
